import { IUploadedFileDto } from "../../../../common/model/file-exchange-dto";

export interface IBtmShippingInfoDto {
    tracking?: string;
    labelFile?: IUploadedFileDto;
}

export class BtmShippingInfo {
    private readonly _tracking?: string;
    private readonly _file?: IUploadedFileDto;

    constructor(dto: IBtmShippingInfoDto) {
        this._tracking = dto.tracking ?? undefined;
        this._file = dto.labelFile ?? undefined;
    }

    get tracking() {
        return this._tracking;
    }

    get file() {
        return this._file;
    }

    public toDto() {
        return {
            tracking: this.tracking,
            labelFile: this.file,
        } as IBtmShippingInfoDto;
    }

    public setTracking(tracking: string) {
        return new BtmShippingInfo({
            ...this.toDto(),
            tracking,
        });
    }

    public setFile(labelFile?: IUploadedFileDto) {
        return new BtmShippingInfo({
            ...this.toDto(),
            labelFile,
        });
    }

    public static createDefault() {
        return [
            new BtmShippingInfo({}),
        ];
    }
}
